module.exports = __webpack_public_path__ + "static/sport/footer-banner1.f9561d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport8/footer-banner1.png
// module id = LkWR
// module chunks = 0